import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { AuthStore } from '../../core/auth/auth.store';
import { Router } from '@angular/router';
// Service
import { AuthzService } from '../../core/auth/authz.service';
import { LoggingService } from '../../core/utils/logging.service';
// RxJS
import { tap } from 'rxjs';
// import { finalize, map, mapTo, Observable, tap } from 'rxjs';
// import { ROUTER_TOKENS } from '../../app.routes';
// PrimeNG
import { ImageModule } from 'primeng/image';
import { ButtonModule } from 'primeng/button';

// const AUTH0_REDIRECT_URI = import.meta.env.NG_APP_AUTH0_REDIRECT_URI;

@Component({
  selector: 'app-auth-callback',
  imports: [ImageModule, ButtonModule, AsyncPipe],
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.scss',
})
export class AuthCallbackComponent implements OnInit {
  private authz = inject(AuthzService);
  private auth0 = inject(AuthService);
  private router = inject(Router);
  private authStore = inject(AuthStore);
  private readonly loggingService = inject(LoggingService);

  previousUrl = signal<string>('');
  onLoading = signal<boolean>(false);

  initialLoadUser$ = this.authz.handleRedirectCallback().pipe(
    tap(() => this.loggingService.error('handleRedirectCallback called')),
    tap((user) => {
      if (!user) {
        this.loggingService.warn('no user, user=!!!', user);
        this.router.navigateByUrl('/');
      } else {
        this.onLoading.set(true);
        this.loggingService.error('✅redirect');
        this.handleRedirectToPreviousUrl();
      }
    })
  );

  // initializeTemplate$: Observable<boolean> = this.authz
  //   .handleRedirectCallback()
  //   .pipe(
  //     tap(() => this.loggingService.error('@@@initializeTemplate$')),
  //     tap(() => this.loggingService.error('store', this.authStore.role)),
  //     tap(() => {
  //       if (!this.authStore.role)
  //         this.router.navigate([ROUTER_TOKENS.AUTH_LOGIN_WITH_SOCIAL]);
  //     }),
  //     tap(() => {
  //       if (this.authStore.role) this.handleRedirect();
  //     }),
  //     map(() => false)
  //   );

  constructor() {
    this.loggingService.warn('🧩0️⃣@@@AuthCallbackComponent');
  }

  ngOnInit() {
    this.loggingService.log('ngOnInit');
    // this.auth0.handleRedirectCallback(window.location.origin).pipe(
    //   tap(() => this.loggingService.error('handleRedirectCallback called')),
    //   tap(() => this.router.navigate(['/choose-company']))
    // ).subscribe()
    this.router.events.pipe().subscribe((event: any) => {
      // You can log other relevant information here
      if (event.url) {
        this.previousUrl.set(event.url);
      }
    });
  }

  handleRedirectToPreviousUrl() {
    this.loggingService.error('###handleRedirect this.previousUrl()', this.previousUrl());
    if (this.previousUrl() !== '/auth-callback') {
      this.router.navigate([`${this.previousUrl()}`]);
    } else {
      this.router.navigate(['/choose-company']);
    }
    this.onLoading.set(false);
  }

  handleRedirect() {
    this.loggingService.error('###handleRedirect');
    this.router.navigate(['/choose-company']);
  }

  debug() {
    this.authz.handleRedirectCallback().subscribe();
  }
}
